import React from "react";
import "../../styles/CarelonRx/mfa.css";

interface ApiErrorBannerProps {
  isVisible: boolean;
  message?: string;
  onRetry: () => void;
  showRetryButton?: boolean;
  buttonText?: string;
  onReturnToLogin?: () => void;
}

const ApiErrorBanner: React.FC<ApiErrorBannerProps> = ({
  isVisible,
  message = "Sorry, we are experiencing technical issues. Please give us time to fix the issues. Then, try again.",
  onRetry,
  showRetryButton = true,
  buttonText = "Retry",
  onReturnToLogin,
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="mfa-soa-error-container">
      <div className="mfa-soa-error-content">
        <img
          src="/assets/carelonRx/images/infoIconRed.svg"
          alt="Error"
          className="mfa-soa-error-icon"
        />
        <div className="mfa-soa-error-text">{message}</div>
      </div>
      {showRetryButton && (
        <div className="mfa-retry-wrapper">
          <button
            onClick={onReturnToLogin || onRetry}
            className="mfa-retry-button"
          >
            {buttonText}
          </button>
        </div>
      )}
    </div>
  );
};

export default ApiErrorBanner;
